import React from 'react';
import glamorous from 'glamorous';

import withPrismJs from '../with-prismjs-hoc';
import { MENU_ENTRIES } from '../constants';

import Definition from './definition';
import Values from './values';
import XmlStructure from './xml-structure';
import FieldProductCode from './field-product-code';
import SubFieldPublication from './sub-field-publication';
import SubFieldSegment from './sub-field-segment';
import SubFieldFamily from './sub-field-family';
import SubFieldClass from './sub-field-class';
import SubFieldBrick from './sub-field-brick';
import SubFieldsAttrs from './sub-field-attrs';

const ProductCodes = ({ onSectionChange }) => {
  return (
    <div data-subsection={MENU_ENTRIES.productCodes}>
      <h3>
        COMPLEX FIELD: PRODUCT CODES
      </h3>
      <br/>
      <div data-subsection={MENU_ENTRIES.productCodesDefinition}>
        <Definition/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesValues}>
        <Values/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesXmlStructure}>
        <XmlStructure/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesFieldProductCode}>
        <FieldProductCode goToExamples={() => onSectionChange(MENU_ENTRIES.productCodesXmlExamples)}/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesSubFieldPublication}>
        <SubFieldPublication/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesSubFieldSegment}>
        <SubFieldSegment/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesSubFieldFamily}>
        <SubFieldFamily/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesSubFieldClass}>
        <SubFieldClass/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesSubFieldBrick}>
        <SubFieldBrick/>
      </div>
      <br/><br/>
      <div data-subsection={MENU_ENTRIES.productCodesSubFieldAttrs}>
        <SubFieldsAttrs goToExamples={() => onSectionChange(MENU_ENTRIES.productCodesXmlExamples)}/>
      </div>
    </div>
  );
};

export default withPrismJs(ProductCodes);



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/index.js